module.exports = {"370125001":"济阳街道","370125002":"济北街道","370125101":"垛石镇","370125102":"孙耿镇","370125103":"曲堤镇","370125104":"仁风镇","370125107":"崔寨镇","370125108":"太平镇","370125109":"回河镇","370125110":"新市镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370125.json
// module id = 1257
// module chunks = 0